import { TAnswerState } from '../../../../containers/FormContainer/types/internal';
import { toArray } from '../../../../utils/toArray';

export const listMapper = (answerState: TAnswerState) => {
  const value = toArray(answerState.value);

  return { [answerState.answerField]: value };
};
